import _ from "lodash";
import React from "react";
import classes from "./TagCard.scss";
import {
  AddCircleOutlined,
  CaretRightFilled,
  PencilLineOutlined,
} from "@toddle-edu/ds-icons";
import Accordian from "UIComponents/Accordian";
import { IconButton } from "@toddle-edu/ds-web";

const TagCard = ({
  showInAccordian,
  data,
  expandedContent,
  icon,
  title,
  subText,
  handleClick,
  showEditIcon = true,
  containerStyle,
  flexContainerStyle,
  testId,
}) => {
  const _TagCard = ({ flexContainerStyle, allowClick = true }) => {
    return (
      <div
        className={classes.flexContainer}
        style={flexContainerStyle ?? {}}
        onClick={allowClick ? handleClick : () => {}}
        data-test-id={testId}
      >
        <div className={classes.innerFlexContainer}>
          {icon}
          <span className={classes.containerTitle}>{title}</span>
        </div>
        <div className={classes.innerFlexContainer}>
          {subText ?? null}
          {showEditIcon ? (
            <IconButton
              variant={"plain"}
              size={"large"}
              onClick={!allowClick ? handleClick : () => {}}
              icon={
                _.isEmpty(data) ? <AddCircleOutlined /> : <PencilLineOutlined />
              }
            />
          ) : null}
        </div>
      </div>
    );
  };

  if (showInAccordian && !_.isEmpty(data))
    return (
      <section className={classes.container}>
        <Accordian
          hideContainerBorder={true}
          showLabelBorder={false}
          customTitleComponent={
            <_TagCard
              flexContainerStyle={{ paddingLeft: "0" }}
              allowClick={false}
            />
          }
          customLeftIcon={
            <CaretRightFilled size={"x-small"} variant={"subtle"} />
          }
          expandedContent={!_.isNil(expandedContent) ? expandedContent : null}
          headerStyle={{ padding: "0" }}
          showLeftArrow={true}
          shouldStopPropagation={true}
          mainContainerClass={classes.accordianMainContainerClass}
          mainContentContainerStyle={{ marginBottom: "0" }}
        />
      </section>
    );

  return (
    <section className={classes.container} style={containerStyle}>
      <_TagCard flexContainerStyle={flexContainerStyle} />
    </section>
  );
};

export default TagCard;
